import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { capitalizeFirstLetter, classnames } from 'helpers/utils';
import { ChevronIcon } from 'assets/icons';
import { RouteName, goToPage } from 'routes';
import styles from './account-vaults-cards-mobile.module.scss';

type AccountVaultsCardsMobileProps = {
  vaults: VaultType[];
  getRenewalExpiration: Function;
  getVaultStatusLabel: Function;
};

const AccountVaultsCardsMobile: React.FC<AccountVaultsCardsMobileProps> = ({
  vaults,
  getRenewalExpiration,
  getVaultStatusLabel,
}) => {
  const getLastBilling = (vault: VaultType) =>
    vault.lastPayment?.amount
      ? `$${vault.lastPayment?.amount.toFixed(2)}`
      : '-';

  return (
    <div className={styles.vaultsCardsMobile}>
      <div
        className={classnames(
          styles.body,
          'text__body__regular__medium__gray700',
        )}
      >
        {vaults.map((vault: VaultType) => (
          <div key={vault.id} className={styles.vaultCard}>
            <div className={styles.leftSize}>
              <div
                className={classnames(
                  'text__body__semi__bold__medium__gray800',
                  styles.vaultName,
                )}
              >
                {vault.title}
              </div>
              <div
                className={classnames(
                  'text__body__regular__small__gray700',
                  styles.subscription,
                )}
              >
                {`${capitalizeFirstLetter(
                  vault.subscriptionType,
                )} Subscription`}
              </div>
              <div className={classnames(styles.lastBilling)}>
                <span
                  className={classnames(
                    'text__body__semi__bold__small__gray700',
                  )}
                >
                  {' '}
                  Last billing:{' '}
                </span>
                <span
                  className={classnames('text__body__regular__small__gray700')}
                >
                  {getLastBilling(vault)}
                </span>
              </div>
              <div className={classnames(styles.renewalExpiration)}>
                <span
                  className={classnames(
                    'text__body__semi__bold__small__gray700',
                  )}
                >
                  {' '}
                  Renewal:{' '}
                </span>
                <span
                  className={classnames('text__body__regular__small__gray700')}
                >
                  {getRenewalExpiration(vault)}
                </span>
              </div>

              {getVaultStatusLabel(vault, styles.status)}
            </div>
            <div className={styles.rightSize}>
              <Button
                className={styles.detailsButton}
                buttonStyle={ButtonStyle.PrimaryGhost}
                buttonSize={ButtonSize.Small}
                onClick={() => {
                  goToPage(RouteName.VaultDetail, { id: vault.id });
                }}
              >
                <ChevronIcon className={styles.chevronIcon} />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { AccountVaultsCardsMobile };
